import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { reduxForm } from 'redux-form';
import idx from 'idx';
import pick from 'lodash/pick';
import { setUnhandledError } from 'error/ducks';
import { fetchCountriesIfNeeded, logout } from 'common/ducks/user';
import { fetchCategoriesIfNeeded } from 'common/ducks/categories';
import { getSubCategory, getCategory } from 'common/ducks/categories';
import { fetchProjectIfNeeded, fetchProject } from 'project/ducks/project';
import { updateProjectRequest } from 'pap/ducks/project';
import { fetchPricing, updateFeaturesRequest, updateAwardsRequest } from 'pap/ducks/pricing';
import { fetchCustomContracts, createCustomContractRequest, deleteCustomContractRequest
  } from 'common/ducks/contract';
import { displayFullScreen, hideFullScreen, getDetailsSteps } from 'pap/ducks/workflow';
import Details from 'pap_v2/components/details';

Details.need = [ fetchCategoriesIfNeeded ];

const getInitialValues = ({ projectData, customContract }) => {
  const values = {};

  if (!projectData) {
    return values;
  }

  values['title'] = projectData.title;

  /* values related to the package selection step */
  values['package'] = projectData.original_package;

  /* initial values related to the ICA contract step */
  values['projectId'] = projectData.id;
  if (customContract) {
    values['contract'] = { isCustom: true, custom_contract: customContract };
  } else {
    values['contract'] = pick(projectData, ['client_legal_name', 'client_legal_country']);
  }

  return values;
}

const mapStateToProps = (state, { params }) => {
  const { pap, form, user, categories, contract } = state;
  const { fullScreen } = pap.workflow;
  const { projectData } = pap.project;
  const { countries } = user;
  const packages = pap.pricing.packages || [];

  const subCategory = projectData? getSubCategory(categories, projectData.sub_category) : {};
  const category = projectData? getCategory(categories.data, projectData.category) : {};

  const steps = getDetailsSteps(state, params);

  const formValues = idx(form, _ => _.pap_details_v2.values) || {};
  const selectedPackage = packages.find(p => p.id === formValues.package);

  /* determine current features/awards/tips/billables based on selected package and project data */
  let features = [], awards = [], tips = [], billables = undefined, hasPackageChanged = false;
  if (selectedPackage && selectedPackage.id !== projectData.original_package) {
    features = selectedPackage.features;
    awards = selectedPackage.awards;
    tips = selectedPackage.package_tips;
    hasPackageChanged = true;
  } else if (projectData) {
    features = projectData.features;
    awards = projectData.award_rules;
    tips = projectData.package_tips;
    billables = projectData.billables;
  }

  const customContract = contract.customContracts.find((c) => c.type === 'ica');
  const initialValues = getInitialValues({ projectData, customContract });

  return {
    user,
    initialValues,
    formValues,
    projectData,
    selectedPackage,
    steps,
    hasPackageChanged,
    packages,
    countries,
    fullScreen,
    features,
    awards,
    tips,
    billables,
    customContract,
    subCategory: subCategory || {},
    category: category || {},
    subCategorySlug: idx(subCategory, _ => _.slug),
    ...params,
  }
}

const wrappedDetails = reduxForm({
  form: 'pap_details_v2',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  /* allow the form the reinitialize with new "pristine" values every time
     the initialValues prop changes, e.g. initial values may be loaded after the form
     is initialized */
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(Details);

export default withRouter(connect(mapStateToProps, {
  fetchProject,
  fetchProjectIfNeeded,
  fetchPricing,
  displayFullScreen,
  hideFullScreen,
  fetchCountriesIfNeeded,
  fetchCustomContracts,
  updateProjectRequest,
  updateFeaturesRequest,
  updateAwardsRequest,
  createCustomContractRequest,
  deleteCustomContractRequest,
  setUnhandledError,
  logout
})(wrappedDetails));



// WEBPACK FOOTER //
// ./pap_v2/containers/details.js